import ErrorLayout from './ErrorLayout';
import SystemErrorDescription from './components/SystemErrorDescription';
import EmailSupportError from './components/EmailSupportError';

export {
  SystemErrorDescription,
  EmailSupportError,
};
export default ErrorLayout;
